import type { ReactNode } from 'react';

import { useShell } from '../app/shell.js';
import { BrandMark } from './brand.js';
import { NotificationBell } from './notification-bell.js';
import { UserMenu } from './user-menu.js';

interface PageHeaderProps {
  readonly title: string;
  readonly subtitle?: string | null;
  readonly children?: ReactNode;
}

export function PageHeader({ title, subtitle, children }: PageHeaderProps): ReactNode {
  const { openNavigation } = useShell();

  return (
    <header className="flex h-topbar shrink-0 items-center gap-3 border-b border-hairline bg-white/70 px-4 backdrop-blur sm:gap-4 sm:px-7 dark:border-dark-line dark:bg-dark-panel/70">
      <span className="lg:hidden">
        <BrandMark tone="white" compact />
      </span>

      <div className="hidden min-w-0 lg:block">
        <h1 className="truncate font-display text-[17px] leading-none font-normal tracking-[-0.02em] text-navy sm:text-[19px] dark:text-dark-ink">
          {title}
        </h1>
        {subtitle === undefined || subtitle === null ? null : (
          <p className="mt-1 truncate text-[12.5px] text-muted">{subtitle}</p>
        )}
      </div>

      <div className="ml-auto flex shrink-0 items-center gap-2">
        {children}
        <NotificationBell />
        <UserMenu />

        <button
          type="button"
          onClick={openNavigation}
          aria-label="Open the navigation"
          className="flex h-9 shrink-0 items-center gap-1.5 rounded-full border border-hairline px-3 text-[13px] font-semibold text-navy transition hover:bg-navy/6 lg:hidden dark:border-dark-line dark:text-dark-ink dark:hover:bg-white/10"
        >
          <span aria-hidden="true" className="flex w-4 flex-col gap-[3px]">
            <span className="h-[2px] w-full rounded-full bg-current" />
            <span className="h-[2px] w-full rounded-full bg-current" />
            <span className="h-[2px] w-full rounded-full bg-current" />
          </span>
          Meni
        </button>
      </div>
    </header>
  );
}
